
export default {
    set({commit}, notification) {
      commit("setNotification", notification);
    }
}